import axios from "axios";

const url = process.env.REACT_APP_BASE_API_URL;

export const usuarioxclienteFindAllById = async (usuId) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(url + `/v2/usuarioxcliente/findbyid/${usuId}`, {
        headers,
    });
};

export const usuarioxclienteDelete = async (usuId, cliId) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.delete(
        url + `/v2/usuarioxcliente/delete/${usuId}/${cliId}`,
        { headers }
    );
};

export const usuarioxclienteUpdate = async (usuId, cliId, locId) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.put(
        url + `/v2/usuarioxcliente/update/${usuId}/${cliId}/${locId}`,
        { headers }
    );
};

export const usuarioxclienteInsert = async (body) => {
    try {
        return await axios.post(url + `/v2/usuarioxcliente/insert`, body);
    } catch (err) {
        console.error(err);
    }
};
